export function normalizedPublicationDate(value: unknown): string | null {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const parsed = new Date(`${value}T00:00:00.000Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value
    ? value
    : null;
}

export function buildJobPostingDate(job: {
  source?: string | null;
  source_published_at?: string | null;
  created_at?: string | null;
}): string | null {
  const sourceDate = normalizedPublicationDate(job.source_published_at);
  if (sourceDate) return sourceDate;
  if (String(job.source || '').toLowerCase() !== 'stagecrew') return null;
  const created = new Date(job.created_at || '');
  if (!Number.isFinite(created.getTime())) return null;
  return normalizedPublicationDate(created.toISOString().slice(0, 10));
}
